import { render } from "./terms-and-conditions.vue?vue&type=template&id=260a9391"
import script from "./terms-and-conditions.vue?vue&type=script&lang=js"
export * from "./terms-and-conditions.vue?vue&type=script&lang=js"

import "./terms-and-conditions.vue?vue&type=style&index=0&id=260a9391&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__